"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentimentButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const Button_1 = require("./Button");
const util_1 = require("../util");
const SentimentButton = (_a) => {
    var { sentiment } = _a, props = __rest(_a, ["sentiment"]);
    const theme = (0, styled_components_1.useTheme)();
    const background = react_1.default.useMemo(() => {
        return (0, util_1.sentimentToPrimaryColor)(sentiment, theme);
    }, [sentiment, theme]);
    return ((0, jsx_runtime_1.jsx)(Button_1.Button, Object.assign({}, props, { background: background, foreground: theme.Color.Layout.Lightest })));
};
exports.SentimentButton = SentimentButton;
